import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import { ChunkLoadErrorBoundary } from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { BoardDisplayAdsContainerProps } from './BoardDisplayAdsContainer';

export const LazyBoardDisplayAdsContainer: FunctionComponent<
  BoardDisplayAdsContainerProps
> = (props) => {
  const BoardDisplayAdsContainer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-header" */ './BoardDisplayAdsContainer'
      ),
    { namedImport: 'BoardDisplayAdsContainer' },
  );

  return (
    <ChunkLoadErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <BoardDisplayAdsContainer {...props} />
      </Suspense>
    </ChunkLoadErrorBoundary>
  );
};
